<template>
  <div class="project">
    <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <img id="navbar-logo" src="../../assets/projects/friendlyrobot/friendlyrobot.jpg" alt="Logo">
      </div>
    </nav>

    <!-- Header Section -->
    <section class="project-header">
      <h1>Bringing Robots to Life: A Colorful Journey</h1>
      <p>
        Welcome to a thrilling journey through my work on creating captivating animations for a friendly robot and integrating them into the frontend. This page is more than just words; it's a visual and interactive adventure!
      </p>
    </section>
 <br>
    <div class="columns is-multiline is-mobile">
        <div class="column is-full is-vcentered">
            <img src="../../assets/projects/friendlyrobot/prototype.jpg" alt="friendlyrobot">
        </div>
        </div>

    <!-- Color Test on Prototype -->
    <section class="project-section">
      <h2>Color Test on Prototype</h2>
      <p>
        To truly bring our friendly robot to life, we embarked on a colorful adventure. Understanding the psychology of colors and their impact on human emotions was a vital step in our journey. The image below is a testament to our meticulous color testing on the prototype. We carefully considered every hue and shade, ensuring that our robot's expressions would resonate with people.
      </p> <br>
      <!-- Image 1 Placeholder -->
      <div class="columns is-multiline is-mobile">
        <div class="column is-half is-vcentered">
            <img src="../../assets/projects/friendlyrobot/colortest.jpg" alt="friendlyrobot">
        </div>
        <div class="column is-half is-vcentered">
          <!-- <video src="../../assets/projects/friendlyrobot/test.mp4" muted controls autoplay></video> -->
        </div>
        </div>
    </section>

    <!-- After Effects Setup -->
    <section class="project-section">
      <h2>Exploring the Magic: After Effects Setup</h2>
      <p>
        Beneath the surface of captivating animations lies the intricate world of software and creativity. In the heart of our animation process is the enchanting realm of Adobe After Effects. This image showcases our setup, revealing the tools, scripts, and files that bring the magic to life. Creating animations that seamlessly transition from one emotion to another is both art and science, and this is where it all begins.
      </p> <br>
      <div class="columns is-multiline is-mobile">
        <div class="column is-full is-vcentered">
            <img src="../../assets/projects/friendlyrobot/ae.jpg" alt="friendlyrobot">
        </div>
        </div>
    </section>

    <!-- Animation Flow -->
    <section class="project-section">
      <h2>Flowing with Animations</h2>
      <p>
        Imagine orchestrating a symphony of emotions for our friendly robot. That's exactly what our animation flow represents. It's our digital dance, guiding the robot's reactions to the ever-changing emotions of those it interacts with. This image captures the elegance of our animation flow, ensuring that transitions are smooth, natural, and engaging.
      </p>
      <br>
      <div class="columns is-multiline is-mobile">
        <div class="column is-full is-vcentered">
            <img src="../../assets/projects/friendlyrobot/flow.png" alt="friendlyrobot">
        </div>
        </div>
    </section>

    <!-- A Glimpse of the Final Prototype -->
    <section class="project-section">
      <h2>A Glimpse of the Final Prototype</h2>
      <p>
        Are you ready to witness the grand finale? Click on the video below to experience the culmination of our hard work—the final prototype. It's the moment when the robot's animations come to life, capturing emotions and reactions with finesse. It's more than just code; it's a vision transformed into a dynamic reality.
      </p>
      <!-- Insert Video of End Prototype Here -->
    </section>

    <!-- Capturing Emotions with Facial Recognition -->
    <section class="project-section">
      <h2>Capturing Emotions with Facial Recognition</h2>
      <p>
        Ever wondered how our robot perceives emotions? Facial recognition is the key. This image reveals the magic that enables our robot to "see" and understand the emotions of the people it interacts with. It's as if the robot possesses its own set of virtual eyes, creating a profound connection with those around it.
      </p>
      <br>
      <div class="columns is-multiline is-mobile">
        <div class="column is-full is-vcentered">
            <img src="../../assets/projects/friendlyrobot/fraunhofer.jpg" alt="friendlyrobot">
        </div>
        </div>
    </section>

    <!-- Meet the Final Prototype -->
    <section class="project-section">
      <h2>Meet the Final Prototype</h2>
      <p>
        Ladies and gentlemen, here's the star of the show—the final prototype! Sleek, modern, and equipped with state-of-the-art technology, it's ready to engage with people. Our captivating animations, along with the power of facial recognition, come together in this impressive robot that's bound to leave a lasting impression.
      </p> <br>
      <div class="columns is-multiline is-mobile">
        <div class="column is-two-third is-vcentered">
          <video src="../../assets/projects/friendlyrobot/1.mp4" muted controls autoplay></video>
        </div>
        <div class="column is-one-third is-vcentered">
          <video src="../../assets/projects/friendlyrobot/2.mp4" muted controls autoplay></video>
        </div>
        </div>
    </section>


    <!-- A World of Emotions -->
    <section class="project-section">
      <h2>A World of Emotions</h2>
      <p>
        We've created a universe of expressions for our robot. While there are 24 unique face animations in our library, we'll showcase just a few. Each animation is a work of art, meticulously crafted to convey a range of emotions. From joy and surprise to contemplation and empathy, our animations breathe life into the robot, making it a relatable and engaging companion.
      </p>
      <!-- Insert a Collage/Carousel of Face Animations Here -->
    </section>

  </div>
</template>

<style scoped>
  
@import 'project.css';

</style>